import React from 'react';

/** A section title. The default is the UI kit's H1 (28/36, semibold); `size`
 * takes Tailwind text classes for a smaller one (text-xl for its H2,
 * text-base for its H3). */
export default function KoobTitle({
  className = '',
  size = 'text-[28px] leading-9 tracking-[-0.01em]',
  children,
}) {
  return (
    <h3 className={`${size} font-semibold text-k-h ${className}`}>
      {children}
    </h3>
  );
}
